/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smart_Select_HelpInputs */

const en_smart_select_help = /** @type {(inputs: Smart_Select_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When performing automatic format, Selected Events are only formatted if required.`)
};

const fr_smart_select_help = /** @type {(inputs: Smart_Select_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lors de l’auto-formatage, les événements sélectionnés ne sont formatés que si nécessaire.`)
};

const de_smart_select_help = /** @type {(inputs: Smart_Select_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei der automatischen Formatierung werden ausgewählte Ereignisse nur dann formatiert, wenn dies erforderlich ist.`)
};

const it_smart_select_help = /** @type {(inputs: Smart_Select_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando si esegue la formattazione automatica, gli eventi selezionati vengono formattati solo se necessario.`)
};

const ru_smart_select_help = /** @type {(inputs: Smart_Select_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При выполнении автоматического форматирования выбранные события форматируются только при необходимости.`)
};

const es_smart_select_help = /** @type {(inputs: Smart_Select_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al realizar el formato automático, los eventos seleccionados solo se formatean si es necesario.`)
};

const zh_cn2_smart_select_help = /** @type {(inputs: Smart_Select_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`执行自动格式化时，仅当需要时才会对选定事件进行格式化。`)
};

const ja_smart_select_help = /** @type {(inputs: Smart_Select_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動フォーマットを実行する場合、選択したイベントは必要な場合にのみフォーマットされます。`)
};

const hi_smart_select_help = /** @type {(inputs: Smart_Select_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित फॉर्मेटिंग करते समय, चयनित इवेंट्स को केवल तभी फॉर्मेट किया जाता है जब आवश्यक हो।`)
};

const pt_pt2_smart_select_help = /** @type {(inputs: Smart_Select_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao executar a formatação automática, os eventos selecionados são formatados somente se necessário.`)
};

/**
* | output |
* | --- |
* | "When performing automatic format, Selected Events are only formatted if required." |
*
* @param {Smart_Select_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const smart_select_help = /** @type {((inputs?: Smart_Select_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smart_Select_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_smart_select_help(inputs)
	if (locale === "de") return de_smart_select_help(inputs)
	if (locale === "it") return it_smart_select_help(inputs)
	if (locale === "ru") return ru_smart_select_help(inputs)
	if (locale === "es") return es_smart_select_help(inputs)
	if (locale === "zh-CN") return zh_cn2_smart_select_help(inputs)
	if (locale === "ja") return ja_smart_select_help(inputs)
	if (locale === "hi") return hi_smart_select_help(inputs)
	if (locale === "pt-PT") return pt_pt2_smart_select_help(inputs)
	return en_smart_select_help(inputs)
});